import React from 'react'
import classNames from 'classnames'
import {ButtonIcon} from 'ac_ui'

interface IToolbarButtonImgProps {
  title: string
  iconPath: string
  className?: string
  classNameWrapper?: string
  onClick: () => void
}

const ToolbarButtonImg: React.FC<IToolbarButtonImgProps> = ({
  className,
  classNameWrapper,
  title,
  iconPath,
  onClick,
}) => {
  return (
    <div className={classNames('d-flex', classNameWrapper)}>
      <ButtonIcon iconPath={iconPath} title={title} isSquare onClick={onClick} className={className} />
    </div>
  )
}

export {ToolbarButtonImg}
